import React from 'react';
import { Tooltip } from '@mantine/core';

type Props = {
  status: 'done' | 'in_progress' | 'failed' | 'not_applicable';
  reason?: string;
};

const COLORS: Record<Props['status'], string> = {
  done: '#12b76a',
  in_progress: '#f59e0b',
  failed: '#dc3c3d',
  not_applicable: '#dc3c3d',
};

const ThumbnailAutomationDot: React.FC<Props> = ({ status, reason }) => {
  const label = reason?.trim() || 'Thumbnail automation status';

  return (
    <Tooltip label={label} withArrow arrowSize={6} multiline maw={280}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'help',
        }}
      >
        <span
          style={{
            width: '1rem',
            height: '1rem',
            borderRadius: '50%',
            backgroundColor: COLORS[status],
          }}
        />
      </span>
    </Tooltip>
  );
};

export default ThumbnailAutomationDot;
